import type { IMaintenanceState } from './types';

export const SLICE_NAMESPACE = 'maintenance';

export const INITIAL_STATE: IMaintenanceState = {
  list: {
    loading: false,
    maintenances: [],
  },
  maintenance: {
    loading: false,
    maintenance: null,
    success: false,
  },
  form: {
    success: false,
    loading: false,
  },
  modal: {
    loading: false,
    success: false,
  },
};
